import { LOB_IDS } from "@/shared/common/static";
import { Car, Heart, HeartPulse, Home, Plane } from "lucide-react";

export type AddQuoteProductKey = "home" | "health" | "life" | "motor" | "travel";

export type AddQuoteProduct = {
  key: AddQuoteProductKey;
  label: string;
  icon: typeof Home;
  lobId?: number;
  accentClassName: string;
  available: boolean;
};

export const ADD_QUOTE_PRODUCTS: AddQuoteProduct[] = [
  {
    key: "travel",
    label: "Add Travel Quotes",
    icon: Plane,
    lobId: LOB_IDS.TRAVEL,
    accentClassName: "bg-sky-50 text-sky-700 border-sky-100",
    available: true,
  },
  {
    key: "health",
    label: "Add Health Quotes",
    icon: HeartPulse,
    lobId: LOB_IDS.HEALTH,
    accentClassName: "bg-rose-50 text-rose-700 border-rose-100",
    available: true,
  },
  {
    key: "motor",
    label: "Add Motor Quotes",
    icon: Car,
    lobId: LOB_IDS.MOTOR,
    accentClassName: "bg-amber-50 text-amber-700 border-amber-100",
    available: true,
  },
  {
    key: "life",
    label: "Add Life Quotes",
    icon: Heart,
    lobId: LOB_IDS.LIFE,
    accentClassName: "bg-violet-50 text-violet-700 border-violet-100",
    available: true,
  },
  {
    key: "home",
    label: "Add Home Quotes",
    icon: Home,
    accentClassName: "bg-lime-50 text-lime-700 border-lime-100",
    available: true,
  },
];

export const getAddQuoteProduct = (product?: string) =>
  ADD_QUOTE_PRODUCTS.find((item) => item.key === product);

export const getAddQuoteProductByLob = (lobId?: number | string | null) => {
  if (lobId === null || lobId === undefined || lobId === "") {
    return undefined;
  }

  const numericLobId = Number(lobId);
  if (Number.isNaN(numericLobId)) {
    return undefined;
  }

  return ADD_QUOTE_PRODUCTS.find((item) => item.lobId === numericLobId);
};
